export const GET_DOCUMENTS_PENDING = '[DOCUMENTS][GET] get Cases pending';
export const GET_DOCUMENTS_SUCCESS = '[DOCUMENTS][GET] get Cases success';
export const GET_DOCUMENTS_FAILURE = '[DOCUMENTS][GET] get Cases failure';
export const HYDRATE_DOCUMENTS_FILTERS = '[DOCUMENTS][FILTERS] hydrate filters';
export const GET_CLIENTS_SUCCESS = '[DOCUMENTS][UPLOAD] get clients';
export const GET_DOCUMENT_TYPES_SUCCESS = '[DOCUMENTS][UPLOAD] get document types';
export const SET_DOCUMENT_ID = '[DOCUMENTS][UPLOAD] set document id';
export const RESET_DOCUMENT_UPLOAD = '[DOCUMENTS][UPLOAD] reset document upload';
export const RESET_DOCUMENT_FIELDS = '[DOCUMENTS][UPLOAD] reset document upload fields';
export const GET_EMPLOYEES_SUCCESS = '[DOCUMENTS][UPLOAD] get employees';
export const GET_DOCUMENT_FIELDS_SUCCESS = '[DOCUMENTS][UPLOAD] get document fields';
export const SAVE_DOCUMENT_SUCCESS = '[DOCUMENTS][UPLOAD] save document';
export const OPEN_DOCUMENTS_SUCCESS = '[DOCUMENTS][POST] open Documents success';
export const DELETE_DOCUMENTS_SUCCESS = '[DOCUMENTS][POST] delete Documents success';
export const GO_TO_DETAILS = '[DOCUMENTS][NAV] to go Document Details';
export const HYDRATE_DOCUMENT_DETAILS = '[DOCUMENTS][DETAILS] hydrate details';
export const DEHYDRATE_DOCUMENT_DETAILS = '[DOCUMENTS][DETAILS] dehydrate details';
export const HYDRATE_DOCUMENTS = '[DOCUMENTS][HYDRATE] hydrate documents';
export const SHOW_DELETE_NOTIFICATION_SUCCESS = '[DOCUMENTS][SHOW] show notification success';
export const HIDE_DELETE_NOTIFICATION_SUCCESS = '[DOCUMENTS][HIDE] hide notification success';
export const REFRESH_DOCUMENT_STATE = '[DOCUMENTS][REFRESH] refresh docs';
export const STORE_CASEMANAGER_ID = '[DOCUMENTS][STORE][ID] stored caseManagerId';
export const OPEN_DOCS_TAB = '[DOCUMENTS][OPEN][TAB] open docs tab';
export const INCREMENT_DOC_COUNT = '[DOCUMENTS][INCREMENT][COUNT] increment document count';
export const DELETE_UPLOAD = '[DOCUMENTS][UPLOAD][DELETE] delete document upload';
export const SET_DOCUMENTS_LOADING = '[DOCUMENTS][SET][LOADING] set documents loading';
export const GET_DOCUMENT_DETAIL_HEADER_SUCCESS = '[DOCUMENTS][GET] get detail header';
